module.exports = __webpack_public_path__ + "img/draw.d0d920bf.svg";